import { Component, OnInit } from '@angular/core';
import { ApiService, } from '../../services/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  public model: RegisterModel;
  public error: string;
  public errors: [string];
  public loginStatus = 0;

  constructor(public apiSvc: ApiService,
    private router: Router) { }

  ngOnInit() {
    this.model = new RegisterModel();
     
  }

  public Register() {
    this.error = "";
    console.log("register", this.model);
    this.loginStatus = 1;
    this.apiSvc.post("api/account/register", this.model).subscribe(
      (data) => {
        console.log(data);
        this.loginStatus = 0;
        this.router.navigate(["/register-confirmation"]);
      },
      (err) => {
 
        this.error = err.Message; 

        console.log(err);
        this.loginStatus = 0;
 
      }
    );
  }


}

 class RegisterModel {
      public Email: string;
      public Password: string;
      public ConfirmPassword: string;
    }
